import { string } from 'yup'
import { safify } from '../utils/safify'

export const designTopic = string()
  .default('')
  .meta({
    label: 'What is this content about?',
    placeholder: 'Try to be as detailed as possible...',
    generateLabel: 'Generate an Idea for Me',
    rows: 4,
    snippets: true,
    generate: true,
    typeahead: true,
  })
  .transform(safify)
